export let props = {
    id: 0,
    client_name: '',
    client_email: '',
    client_mobile: '',
    event_type: 0,
    guest_count: 100,
    emi_months: 0,
    event_date: 
        {   
            fixed_date: true, 
            event_month: new Date().getMonth()+1, 
            event_day:  new Date().getDate(), 
            event_year:  new Date().getFullYear()
        }
}




// WEBPACK FOOTER //
// ./src/store/modules/budget/properties.js